const fetchConfig = {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', Accept: `application/json` }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.cart = null
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.initLoading()
    this.productAdd()
    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = window.FoxThemeEvents.subscribe('ON_ITEM_ADDED', async (parsedState) => {
      if (window.FoxThemeSettings.template === 'cart') {
        this.renderContents(parsedState)
      }
      const cart = await FoxThemeCartHelpers.getState()
      if (cart) {
        this.cart = cart
        FoxThemeCartHelpers.updateCartCount(cart.item_count)
      }
    });

    window.FoxThemeEvents.subscribe('ON_CART_UPDATED', (cart) => {
      this.cart = cart
      FoxThemeCartHelpers.updateCartCount(cart.item_count)
      this.classList.toggle('is-empty', cart.item_count === 0);
    });

    window.FoxThemeEvents.subscribe('ON_ITEM_ADDED', (cart) => {
      this.classList.toggle('is-empty', cart.item_count === 0);
    })
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  initLoading() {
   
    this.loading = new window.FoxTheme.AnimateLoading(document.body, { overlay: this.querySelector('.f-cart__items')})
    
  }

  // onChange(event) {
   
  //   if (event.target.getAttribute('name') !== 'updates[]') return;
  
  //   this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
   
  // }

onChange(event) {

    var this_ = this;
      if (event.target.classList.contains('yard_panel_qunty')) {
        if(event.target.value < 1) {
            var check_key = event.target.getAttribute('data-key');
            var default_value = event.target.getAttribute('data-defaultv');
            const wrapper = event.target.closest('.f-cart-item__quantity');
            const errorBox = wrapper.querySelector('.f-cart__error');
            errorBox.textContent = 'Minimum Quantity: 1 Yard';
            errorBox.style.display = 'block';
            setTimeout(function() {
              errorBox.style.display = 'none';
              event.target.value = default_value;
            },2500);
          } else {
        
          var check_key = event.target.getAttribute('data-key');
          var check_index = document.querySelector('.yard_panel_qunty[data-key="'+check_key+'"]').getAttribute('data-index');
          var item_available_q = document.querySelector('.yard_panel_qunty[data-key="'+check_key+'"]').getAttribute('data-inventory');  
          var qty = document.querySelector('.yard_panel_qunty[data-key="'+check_key+'"]').value;
          var data_for_yard = document.querySelector('.yard_panel_qunty[data-key="'+check_key+'"]').getAttribute('data-qtyfor');
          var check_continue = document.querySelector('.yard_panel_qunty[data-key="'+check_key+'"]').getAttribute('data-continuesell');
        
          if (data_for_yard == 'yard') {
                var yard_current_qty = document.querySelector('.custom_itg_yard[data-key="'+check_key+'"]').value;
                var yardqty = qty / 4;
                var mainqty = qty * 4;
                var get_yard_available = document.querySelector('.custom_itg_yard[data-key="'+check_key+'"]').getAttribute('data-inventory');
                var check_index = document.querySelector('.custom_itg_yard[data-key="'+check_key+'"]').getAttribute('data-index');

                var check_continue = document.querySelector('.custom_itg_yard[data-key="'+check_key+'"]').getAttribute('data-continuesell');
            //     console.log(qty+'--'+get_yard_available)

            // console.log(check_continue);
            if (check_continue == 'on') {
                 var mainqty = parseInt(mainqty);
                 this_.updateQuantity(check_index,mainqty , "updates[]",check_key,"yard");
            } else {
            
              if (mainqty > get_yard_available) {
                    var show_noteyard = qty
                    var data_error = `<div class="f-notification warning show">
                                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                      </svg>
                                      <div class="ml-3">
                                        Maximum Quantity Available: (${item_available_q})
                                      </div>
                                    </div>`
                        var error_selector = document.querySelector('.f-cart-item[data-cart-item="'+check_key+'"]');
                        if (error_selector) {
                          if (error_selector.querySelector('.f-notification')) {
                             error_selector.querySelector('.f-notification').remove();
                          }
                          error_selector.querySelector('.f-cart__quantity-wrapper').insertAdjacentHTML('afterend', data_error);
                          setTimeout(() => {
                            error_selector.querySelector('.f-notification').classList.add('hide');
                          }, 4000);
                        }
              } else {
                // console.log(mainqty);
                // console.log(check_key);
                var mainqty = parseInt(mainqty);
                 this_.updateQuantity(check_index,mainqty , "updates[]",check_key,"yard");
              }
            }
            
          } else {
           // console.log(qty+'-'+item_available_q)
              if (check_continue == 'on') {
                     this_.updateQuantity(check_index, qty, "updates[]",check_key,"panel");
              } else {
               if (qty > item_available_q) {
                      console.log('error panel');
                     var data_error = `<div class="f-notification warning show">
                            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <div class="ml-3">
                              Maximum Quantity Available: (${item_available_q})
                            </div>
                          </div>`
                        var error_selector = document.querySelector('.f-cart-item[data-cart-item="'+check_key+'"]');
                        if (error_selector) {
                          if (error_selector.querySelector('.f-notification')) {
                          error_selector.querySelector('.f-notification').remove();
                          }                          
                          error_selector.querySelector('.f-cart__quantity-wrapper').insertAdjacentHTML('afterend', data_error);
                          setTimeout(() => {
                          error_selector.querySelector('.f-notification').classList.add('hide');
                        }, 4000);
                        }
              } else {
                    this_.updateQuantity(check_index, qty, "updates[]",check_key,"panel");
              }
             }
          }
        
         return;
      }

        }
    if (event.target.getAttribute('name') !== 'updates[]') return;
   this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'),event.target.dataset.key,event.target.dataset.qtyfor);

}

  getSectionsToRender() {
   
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name,key,check_yard) {
    this.enableLoading();
    let thisElement = this;

    console.log(line);
    // var line = key;
     const properties = {};
    if (check_yard == 'yard') {
      var in_yr = quantity / 4;
      var property_selector = document.querySelector('.item_properties[data-finder="' + key + '"]');
      if (property_selector) {
         property_selector.querySelectorAll('.line_item_properties').forEach(function (data) {
          const propertyName = data.querySelector('dt')?.innerText.trim(); // Safe access in case `dt` is missing
          const propertyValue = data.querySelector('dd')?.innerText.trim(); // Safe access in case `dd` is missing
          if (propertyName && propertyValue) {
            properties[propertyName] = propertyValue; // Add to the properties object
          }
        });
       
        if (properties["Yards"]) {
          properties["Yards"] = in_yr;
        }
      }
      var body = JSON.stringify({
        line, 
        quantity,
        properties: properties,
        sections: this.getSectionsToRender().map((section) => section.section), 
        sections_url: window.location.pathname, 
      });
    } 
    else {
    var body = JSON.stringify({
      line, 
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section), 
      sections_url: window.location.pathname, 
    });
    }
   

    
    fetch(`${FoxThemeSettings.routes.cart_change_url}`, { ...fetchConfig, ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
    //  console.log(parsedState);
      const updatedLine = this.querySelector(`#CartItem-${line}, #CartDrawer-Item-${line}`)

      const quantityElement = updatedLine.querySelector('[name="updates[]"]');
      const items = document.querySelectorAll('.f-cart-item');

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer');

      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawer) cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);

      this.renderContents(parsedState)
      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;

      let message = '';
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        if (typeof updatedValue === 'undefined') {
          message = window.FoxThemeStrings.cartError;
        } else {
          message = window.FoxThemeStrings.quantityError.replace('[quantity]', updatedValue);
        }
      }

      //this.updateLiveRegions(line, message);

      const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawer
          ? trapFocus(cartDrawer, lineItem.querySelector(`[name="${name}"]`))
          : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawer) {
        //TODO: Check later
        // trapFocus(cartDrawer.querySelector('.drawer__inner-empty'), cartDrawer.querySelector('a'));
      } else if (document.querySelector('.f-cart-item') && cartDrawer) {
        trapFocus(cartDrawer, document.querySelector('.f-cart-item__name'));
      }
      window.FoxThemeEvents.emit(`ON_CART_UPDATED`, parsedState)
    })
    .catch(() => {
      const errors = document.querySelector('#cart-errors, #CartDrawer-CartErrors');
      if (errors) {
        errors.textContent = window.FoxThemeStrings.cartError;
      }
    })
    .finally(() => {
      this.loading.finish();
      thisElement.productAdd();
      
    });    
  }


    productAdd() {
  
          const elements_items = this.querySelectorAll('.simple_variant_add');
          let itemqtycount = 0;
      
          elements_items.forEach(element => {
              const quantityInput = element.closest('.f-cart-item')?.querySelector('.f-quantity__input.form-control');
              const value = quantityInput ? parseInt(quantityInput.value, 10) : 0;
              itemqtycount += value;
          });


      
          if (itemqtycount > 5) {
              let additionalQuantity = itemqtycount - 5;
              fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                  let cartitems = cart.items;
                  let hasAdditionalSwatch = false;
                  let existingQuantity = 0;
                  cartitems.forEach(item => {
                      if (item.handle === 'additional-swatch') {
                          hasAdditionalSwatch = true;
                          existingQuantity = item.quantity;
                      }
                  });
      
                  if (hasAdditionalSwatch) {
                      $.ajax({
                          type: 'POST',
                          url: '/cart/change.js',
                          data: {
                              id: '49875565805861',
                              quantity: additionalQuantity
                          },
                          dataType: 'json',
                          success: function () {
                              if (additionalQuantity !== existingQuantity) {
                                  location.reload();
                              }
                          }
                      });
                  } else {
                      $.ajax({
                          type: 'POST',
                          url: '/cart/add.js',
                          data: {
                              id: '49875565805861', 
                              quantity: additionalQuantity,
                              properties: {
                                  Note: '$1 for each swatch after 5 free swatches'
                              }
                          },
                          dataType: 'json',
                          success: function () {
                              location.reload();
                          }
                      });
                  }
              });
          } else {

            var check_charge = document.querySelector('tr[data-cart-item-product-id="9674389651749"]');
            if (check_charge){
              $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  data: {
                      id: '49875565805861', 
                      quantity: 0
                  },
                  dataType: 'json',
                  success: function () {
                    
                    location.reload();
                  }
              });
            }              
          }


      // my code

      

      
}

 

  
  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      if (elementToReplace) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      }
    });
  }

  updateLiveRegions(line, message) {
    
    if (!message) return;
    const lineItemError = this.querySelector(`#CartItem-${line}, #CartDrawer-Item-${line}`);
    
    window.FoxTheme.Notification.show({
      target: lineItemError.querySelector('.f-cart-item__quantity, .f-cart-drawer__error'),
      method: 'appendChild',
      type: 'warning',
      message: message,
      last: 5000
    })
   
   this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const domParser = new DOMParser().parseFromString(html, 'text/html')
    return domParser.querySelector(selector) ? domParser.querySelector(selector).innerHTML : '';
  }

  enableLoading() {
    this.loading.start()
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }
}

customElements.define('cart-items', CartItems);







